import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home/index.vue')
  },
  {
    path: '/swing-analysis',
    name: 'swingAnalysis',
    component: () => import('@/views/SwingAnalysis/index.vue')
  },
  {
    path: '/sports-portrait',
    name: 'sportsPortrait',
    component: () => import('@/views/SportsPortrait/index.vue')
  },
  {
    path: '/account',
    name: 'account',
    component: () => import('@/views/Account/index.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/Privacy/index.vue')
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('@/views/Terms/index.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/About/index.vue')
  },
  {
    // 路由重定向
    path: "/",
    redirect: {
      path: "/",
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // 每次路由跳转之后 新页面加载在x轴和y轴的初始位置
  scrollBehavior() {
    return {
      left: 0,
      top: 0,
    };
  },
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  next();
});

export default router
